// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__uYVRc","newExpiryDate":"styles_newExpiryDate__2BNdf","footer":"styles_footer___fEs_"};